import React from "react";
import { Route, Routes } from "react-router";
import { CBSA } from "../UtilityData/CBSA";

const ImportCensus = ({ navigate }) => {
  return (
    <Routes>
      <Route index element={<h1>ImportCensus Index Page Here</h1>} />
      {/* <Route path="ImportCensus" element={<ImportCensus navigate={navigate} />} />
      <Route
        path="importcensus"
        element={<ImportCensus navigate={navigate} />}
      />
      <Route
        path="report&export"
        element={<ReportExport navigate={navigate} />}
      /> */}
    </Routes>
  );
};

export default ImportCensus;
